// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"7777dce6","460":"360dfcd0","544":"024ce392","632":"31f7a7df","636":"57e51075","702":"956f5978","815":"d2d13b78","872":"bd2eb52a"}[chunkId] + ".css";
};